import React, { Component } from 'react';
import { Field, reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Form, Grid } from 'semantic-ui-react';
import moment from 'moment';

import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';
import {
  InputField,
  DatePickerField,
  CheckboxField,
} from 'Common/SemanticWrapper';
import { SCHOOL_CALENDAR_EXCEPTION_FORM_NAME } from 'Common/FormEnum';

class ExceptionForm extends Component {
  componentDidUpdate(prevProps) {
    const { formValues, change } = this.props;
    const { formValues: prevValues } = prevProps;

    if (prevValues[Fields.BeginDay] !== formValues[Fields.BeginDay]) {
      change(Fields.EndDay, formValues[Fields.BeginDay]);
    }
  }

  render() {
    return (
      <Form>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Field
                component={InputField}
                label={'Description'}
                maxLength={30}
                name={Fields.Description}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                className={'school-calendar--serving-checkbox'}
                component={CheckboxField}
                label={'Is Serving?'}
                name={Fields.IsServing}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Field
                component={DatePickerField}
                dateFormat="MM/DD/YYYY"
                label={'Begin Day'}
                name={Fields.BeginDay}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={DatePickerField}
                dateFormat="MM/DD/YYYY"
                label={'End Day'}
                name={Fields.EndDay}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const _moment = date => moment(date, 'MM/DD/YYYY');

const validate = (values, ownProps) => {
  const { firstDay, lastDay } = ownProps;
  const errors = {};

  if (!values[Fields.Description] || values[Fields.Description].length === 0) {
    errors[Fields.Description] = 'Description is required';
  }

  if (!values[Fields.BeginDay]) {
    errors[Fields.BeginDay] = 'Begin Day is required';
  }

  if (!values[Fields.EndDay]) {
    errors[Fields.EndDay] = 'End Day is required';
  }

  if (
    _moment(values[Fields.BeginDay]).isAfter(_moment(values[Fields.EndDay]))
  ) {
    errors[Fields.BeginDay] = 'Begin Day should be on or before End Day';
  }

  if (_moment(values[Fields.BeginDay]).isBefore(_moment(firstDay))) {
    errors[Fields.BeginDay] =
      'Begin Day should be on or after School First Day';
  }

  if (_moment(values[Fields.EndDay]).isAfter(_moment(lastDay))) {
    errors[Fields.EndDay] = 'End Day should be on or before School Last Day';
  }

  return errors;
};

const mapStateToProps = state => {
  const formValues = getFormValues(SCHOOL_CALENDAR_EXCEPTION_FORM_NAME)(state);

  return {
    formValues,
  };
};

ExceptionForm = connect(mapStateToProps)(ExceptionForm);

export default reduxForm({
  validate,
  form: SCHOOL_CALENDAR_EXCEPTION_FORM_NAME,
  destroyOnUnmount: true,
})(ExceptionForm);



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/components/ExceptionForm.js